var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("list-item", {
    attrs: {
      booking: _vm.booking,
      link: { name: "vetting.show", params: { id: _vm.booking.id } },
    },
    scopedSlots: _vm._u(
      [
        {
          key: "pill",
          fn: function () {
            return [
              !_vm.booking.read
                ? _c("span", { staticClass: "label label-default m-r-xs" }, [
                    _vm._v("NEW"),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.$isNflClient && _vm.booking.talent_count === 0
                ? _c("span", { staticClass: "label label-info m-r-xs" }, [
                    _vm._v("Player relations to add players"),
                  ])
                : _vm._e(),
            ]
          },
          proxy: true,
        },
        {
          key: "categories",
          fn: function () {
            return [
              _vm.booking.opportunities && _vm.booking.opportunities.length
                ? _c(
                    "div",
                    { staticClass: "flex flex-wrap" },
                    _vm._l(_vm.booking.opportunities, function (app) {
                      return _c(
                        "span",
                        { key: app.id, staticClass: "label label-info" },
                        [_vm._v(_vm._s(app.name))]
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ]
          },
          proxy: true,
        },
        {
          key: "status",
          fn: function () {
            return [
              _vm.booking.urgent
                ? _c("div", { staticClass: "spacer-b-2" }, [
                    _c("span", { staticClass: "label label-danger" }, [
                      _vm._v("Urgent"),
                    ]),
                  ])
                : _vm._e(),
            ]
          },
          proxy: true,
        },
        _vm.userCanSeeBudget
          ? {
              key: "hero",
              fn: function () {
                return [
                  _vm.$userIsTalent || _vm.$userIsManager
                    ? [
                        _vm.booking.local_currency
                          ? [
                              _vm._v(
                                "\n        " +
                                  _vm._s(
                                    _vm._f("nullable")(
                                      _vm._f("abbreviatedCurrency")(
                                        _vm.booking
                                          .local_currency_budget_per_star_as_user_rate,
                                        _vm.booking.local_currency
                                      )
                                    )
                                  ) +
                                  "\n      "
                              ),
                            ]
                          : [
                              _vm._v(
                                "\n        " +
                                  _vm._s(
                                    _vm._f("nullable")(
                                      _vm._f("abbreviatedCurrency")(
                                        _vm.booking
                                          .budget_per_star_as_user_rate,
                                        _vm.booking.currency
                                      )
                                    )
                                  ) +
                                  "\n      "
                              ),
                            ],
                      ]
                    : _vm.bookingGrandTotalBudget
                    ? _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("nullable")(
                              _vm._f("abbreviatedCurrency")(
                                _vm.bookingGrandTotalBudget,
                                _vm.booking.local_currency
                                  ? _vm.booking.local_currency
                                  : _vm.booking.currency
                              )
                            )
                          )
                        ),
                      ])
                    : _c("span", [_vm._v("View")]),
                ]
              },
              proxy: true,
            }
          : null,
        {
          key: "admin",
          fn: function () {
            return [
              _vm.booking.local_currency
                ? _c("div", { staticClass: "spacer-b-1 flex flex-row" }, [
                    _c("i", { staticClass: "fa fa-info-circle spacer-r-1" }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "Estimated conversion to " +
                          _vm._s(_vm.booking.local_currency) +
                          ". Actual amount may differ due to fluctuating conversion rates."
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }